<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 12:49:04
 * @LastEditTime: 2022-12-29 16:04:39
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page7-wrapper">
        <div class="page7-content">
          <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-52ZvU7afMyKhmFaq7.png"/> -->
          <!-- <img class="start-icon animate__animated  animate__pulse animate__infinite" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-52P52winsTkkqhcG48h.png"/> -->
          <!-- <img class="page3-title" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-16-09IroyeHnZx79tNeP.png"/> -->
          <div class="page7-main">
            这一年<br>
            你一共荣登了<br>
            <span class="report-num"> {{reportData.award.length}} </span>次每月评优<br>
            <template v-if="reportData.fansNum">收获了<span class="report-num"> {{ reportData.fansNum }} </span>粉丝<br></template>
            <!-- 给你点赞最多的人是<span class="report-num-text"> {{ reportData.userOfMostLikeYou }} </span><br>
            最常浏览你创作的人是<span class="report-num-text"> {{ reportData.userOfMostViewYou }} </span><br> -->
            技术担当<br>
            闪耀如星<br>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page7',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
      changeTime() {
        const changeTime = this.reportData.exchange?.createTime;
        if (changeTime) {
          const [day,] = changeTime.split(' ')
           const [, month, date] = day.split('-')
            return {
                month: +month,
                date: +date
            }
        }
        return {
          month: '',
          date: ''
        }
      }
    },
    methods: {
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page7-wrapper {
    height: 100vh;
    width: 100%;
    padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-17-567h6MhuZITuoSq5R.jpg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .page7-content {
        font-size: 0.4rem;
        line-height: 2.8;
        font-weight: bold;
        color: #FAFAD7;
        
        .page-title {
            width: 100px;
            color: #fff;
            background: #2D97E1;
            border-radius: 4px;
            margin-bottom: 20px;
            font-weight: 500;
            line-height: 1;
            padding: 6px 0;
            position: relative;
            text-align: center;
            &:after {
                position: absolute;
                display: block;
                content: '';
                width: 300px;
                height: 4px;
                bottom: -4px;
                border-radius: 4px;
                background: #D9F0F9;
            }
        }
        .page7-main {
          // background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-11-52ZvU7afMyKhmFaq7.png');
          // background-size: 100% 100%;
          // width: 80%;
          // border-radius: 8px;
          margin: 3.5rem auto 0;
          // padding: 36px 24px 80px;
          // min-height: 60vh;
          box-sizing: border-box;
        }
    }
    .page7-badge {
      text-align: left;
    }
    .page7-exchange {
      text-align: right;
      margin-top: 40px;
    }
    .report-num {
        color: #f1f406;
        font-weight: 500;
        font-size: 0.5rem;
    }
        .report-num-text {
       color: #f1f406;
        font-weight: 500;
        font-size: 0.45rem; 
    }
    .start-icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 3rem;
      height: 3rem;
    }
    .page3-title {
        // width: 60%;
        height: 1.5rem;
        margin-top: 2rem;
    }
}
@media screen and (min-width: 1980px) {
  #page7-wrapper {
    .page7-content {
      .page7-main {
        margin-top: 25vh;
      }
    }
  }
}
</style>
